/**
 * T108: Categories Route
 * Route for categories management page
 */

import { createFileRoute } from '@tanstack/react-router'
import { CategoriesPage } from '@/pages/settings/categories-page'

export const Route = createFileRoute('/_authenticated/settings/categories')({
  component: CategoriesPage,
})
